/* global jQuery: false, endpoints: false */

import Vue from 'vue';

(function () {
    'use strict';
    const portEl = document.querySelector('.cw-portfolio-block');

    if (portEl) {

        new Vue({
            el: portEl,
            data: {
                results: {},
                cats: [{
                    title: 'All Investments',
                    id: 0,
                    slug: '',
                }],
                loading: false,
                activeCat: '',
                barLeft: 0,
                barWidth: 0,
            },
            updated: function() {
                this.updateBar();
            },
            mounted: function() {
                this.getData();
            },
            methods: {
                // shuffleCards: function(cat) {
                //     window.breakpoint.refreshValue();
                //     let size = 1;

                //     // set the number of columns per break point
                //     if (window.breakpoint.value == 'phone') {
                //         size = 1;
                //     }

                //     if (window.breakpoint.value == 'tablet') {
                //         size = 2;
                //     }

                //     if (window.breakpoint.value == 'desktop') {
                //         size = 3;
                //     }

                //     // let count = this.portItems.length;
                //     // let rows = Math.ceil(count / size);

                //     let x = 0;                    

                //     const portItems = portEl.querySelectorAll('.port-item');

                //     for (let i = 0; i < portItems.length; i++) {
                //         const pi = portItems[i];

                //         // reset each card
                //         this.removeClass(pi, 'showing');
                //         pi.removeAttribute('style');

                //         // measure each card
                //         let h = pi.offsetHeight;
                //         let w = pi.offsetWidth;

                //         // determine which cards should be showing (card that match cat)
                //         if (this.hasClass(pi, cat)) {
                //            this.addClass(pi, 'showing');

                //             let current_row = Math.floor(x / size);
                //             let current_col = x % size;

                //             pi.style.top = current_row * h + 'px';
                //             pi.style.top = current_col * w + 'px';

                //             x++;
                //         }
                //     }
                // },
                changeCat: function (catSlug) {
                    this.activeCat = catSlug;
                    this.updateBar();
                    // this.shuffleCards(catSlug);
                },
                updateBar: function() {
                    const activeCatEl = document.querySelector('.active-cat');
                    
                    if (activeCatEl) {
                        this.barWidth = activeCatEl.offsetWidth;
                        this.barLeft = activeCatEl.offsetLeft;
                    } else {
                        this.activeCat = this.cats[0].slug;
                    }
                },
                getData: function(){
                    this.loading = true;
                    let self = this;

                    jQuery.ajax({
                        url: endpoints.portfolio,
                        type: 'GET',
                        success: function(data){
                            // console.log('success');
                            // console.log(data);
                            if(data.items) {
                                self.results = data.items;
                            }

                            if(data.cats.length) {
                                if(data.cats.length == 1) {
                                    self.cats = [];
                                }

                                for (let c = 0; c < data.cats.length; c++) {
                                    const cat = data.cats[c];
                                    self.cats.push(cat);
                                }
                            }

                            self.loading = false;
                        },
                        error: function(jqXHR, textStatus, errorThrown){
                            console.log('jqXHR: ', jqXHR);
                            console.log('textStatus: ', textStatus);
                            console.log('errorThrown: ', errorThrown);
                            console.log('status: ', jqXHR.status);
                            console.log('responseText: ', jqXHR.responseText);

                            self.loading = false;
                        }
                    });
                },
                removeClass: function(el, className) {
                    if (el.classList)
                        el.classList.remove(className);
                    else
                        el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                },
                addClass: function(el, className) {
                    if (el.classList)
                        el.classList.add(className);
                    else
                        el.className += ' ' + className;
                },
                hasClass: function(el, className) {
                    if (el.classList) {
                        return el.classList.contains(className);
                    } else {
                        return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
                    }
                }
            }
        });
    }
}());